"use strict";

exports.__esModule = true;
exports.CommentsRow = exports.CommentWrapper = exports.AlertCommentsWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AlertCommentsWrapper = exports.AlertCommentsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__AlertCommentsWrapper",
  componentId: "sc-9d3du6-0"
})(["display:flex;flex-direction:column;opacity:", ";"], function (props) {
  return props.disabled ? "0.2" : "1";
});
var CommentsRow = exports.CommentsRow = _styledComponents["default"].div.withConfig({
  displayName: "styles__CommentsRow",
  componentId: "sc-9d3du6-1"
})(["display:flex;flex-direction:column;margin-bottom:0;align-items:flex-start;min-height:90px;overflow:auto;max-height:", ";"], function (props) {
  return props.isFullScreen ? "calc(100vh - 320px)" : "none";
});
var CommentWrapper = exports.CommentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__CommentWrapper",
  componentId: "sc-9d3du6-2"
})(["display:flex;flex:1;justify-content:flex-start;align-items:center;width:100%;border-bottom:1px solid ", ";padding:0.5rem 0;"], (0, _Theme.val)("LogbookBorderColor"));